module.exports = __webpack_public_path__ + "static/media/2025_NEW_COWI.9637306a.pdf";